import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Printer, Download, AlertCircle } from 'lucide-react';
import { usePageTitle } from '../components/AppShell';
import { useLang } from '../lib/lang';
import { type AuthUser } from '../lib/auth';
import { T } from '../lib/tokens';

interface Props { user: AuthUser }

interface Period { period: number; start: string; end: string }
interface ClassBlock { subject: string; subjectEn: string; teacher: string; room: string; color: string }
type TimetableRow = { period: Period; days: (ClassBlock | null)[] }

const PERIODS: Period[] = [
  { period:1, start:'07:30', end:'08:10' },
  { period:2, start:'08:10', end:'08:50' },
  { period:3, start:'08:50', end:'09:30' },
  { period:4, start:'09:30', end:'10:10' },
  { period:5, start:'10:10', end:'10:50' }, // recess
  { period:6, start:'11:10', end:'11:50' },
  { period:7, start:'11:50', end:'12:30' },
  { period:8, start:'12:30', end:'13:10' },
];

const RECESS_PERIOD = 5;

// Mon=0..Fri=4
const TIMETABLE: TimetableRow[] = [
  { period: PERIODS[0]!, days: [
    { subject:'Bahasa Melayu',    subjectEn:'Malay Language',   teacher:'Cikgu Aishah',  room:'B201', color:'#DBEAFE' },
    { subject:'Matematik',        subjectEn:'Mathematics',      teacher:'Cikgu Ahmad',   room:'A104', color:'#DCFCE7' },
    { subject:'Sains',            subjectEn:'Science',          teacher:'Cikgu Nurul',   room:'Lab1', color:'#F0FDF4' },
    { subject:'Bahasa Inggeris',  subjectEn:'English',          teacher:'Cikgu Rashid',  room:'B203', color:'#FEF3C7' },
    { subject:'Sejarah',          subjectEn:'History',          teacher:'Cikgu Masri',   room:'A102', color:'#FEE2E2' },
  ]},
  { period: PERIODS[1]!, days: [
    { subject:'Bahasa Melayu',    subjectEn:'Malay Language',   teacher:'Cikgu Aishah',  room:'B201', color:'#DBEAFE' },
    { subject:'Matematik',        subjectEn:'Mathematics',      teacher:'Cikgu Ahmad',   room:'A104', color:'#DCFCE7' },
    { subject:'Sains',            subjectEn:'Science',          teacher:'Cikgu Nurul',   room:'Lab1', color:'#F0FDF4' },
    { subject:'Bahasa Inggeris',  subjectEn:'English',          teacher:'Cikgu Rashid',  room:'B203', color:'#FEF3C7' },
    { subject:'P.Islam',          subjectEn:'Islamic Studies',  teacher:'Ustaz Hafiz',   room:'A201', color:'#F5F3FF' },
  ]},
  { period: PERIODS[2]!, days: [
    { subject:'Matematik',        subjectEn:'Mathematics',      teacher:'Cikgu Ahmad',   room:'A104', color:'#DCFCE7' },
    { subject:'Bahasa Inggeris',  subjectEn:'English',          teacher:'Cikgu Rashid',  room:'B203', color:'#FEF3C7' },
    { subject:'Geografi',         subjectEn:'Geography',        teacher:'Cikgu Noraini', room:'A103', color:'#FFFBEB' },
    { subject:'Sejarah',          subjectEn:'History',          teacher:'Cikgu Masri',   room:'A102', color:'#FEE2E2' },
    { subject:'Matematik',        subjectEn:'Mathematics',      teacher:'Cikgu Ahmad',   room:'A104', color:'#DCFCE7' },
  ]},
  { period: PERIODS[3]!, days: [
    { subject:'Sains',            subjectEn:'Science',          teacher:'Cikgu Nurul',   room:'Lab1', color:'#F0FDF4' },
    { subject:'P.Islam',          subjectEn:'Islamic Studies',  teacher:'Ustaz Hafiz',   room:'A201', color:'#F5F3FF' },
    { subject:'Bahasa Melayu',    subjectEn:'Malay Language',   teacher:'Cikgu Aishah',  room:'B201', color:'#DBEAFE' },
    { subject:'Matematik',        subjectEn:'Mathematics',      teacher:'Cikgu Ahmad',   room:'A104', color:'#DCFCE7' },
    { subject:'Sains',            subjectEn:'Science',          teacher:'Cikgu Nurul',   room:'Lab1', color:'#F0FDF4' },
  ]},
  { period: PERIODS[4]!, days: [null, null, null, null, null] }, // recess
  { period: PERIODS[5]!, days: [
    { subject:'Geografi',         subjectEn:'Geography',        teacher:'Cikgu Noraini', room:'A103', color:'#FFFBEB' },
    { subject:'Sejarah',          subjectEn:'History',          teacher:'Cikgu Masri',   room:'A102', color:'#FEE2E2' },
    { subject:'P.Islam',          subjectEn:'Islamic Studies',  teacher:'Ustaz Hafiz',   room:'A201', color:'#F5F3FF' },
    { subject:'Sains',            subjectEn:'Science',          teacher:'Cikgu Nurul',   room:'Lab1', color:'#F0FDF4' },
    { subject:'Bahasa Melayu',    subjectEn:'Malay Language',   teacher:'Cikgu Aishah',  room:'B201', color:'#DBEAFE' },
  ]},
  { period: PERIODS[6]!, days: [
    { subject:'Bahasa Inggeris',  subjectEn:'English',          teacher:'Cikgu Rashid',  room:'B203', color:'#FEF3C7' },
    { subject:'Geografi',         subjectEn:'Geography',        teacher:'Cikgu Noraini', room:'A103', color:'#FFFBEB' },
    { subject:'Matematik',        subjectEn:'Mathematics',      teacher:'Cikgu Ahmad',   room:'A104', color:'#DCFCE7' },
    { subject:'P.Islam',          subjectEn:'Islamic Studies',  teacher:'Ustaz Hafiz',   room:'A201', color:'#F5F3FF' },
    { subject:'P.Jasmani',        subjectEn:'P.Education',      teacher:'Cikgu Azlan',   room:'Gym',  color:'#ECFDF5' },
  ]},
  { period: PERIODS[7]!, days: [
    { subject:'P.Islam',          subjectEn:'Islamic Studies',  teacher:'Ustaz Hafiz',   room:'A201', color:'#F5F3FF' },
    { subject:'Bahasa Melayu',    subjectEn:'Malay Language',   teacher:'Cikgu Aishah',  room:'B201', color:'#DBEAFE' },
    { subject:'Bahasa Inggeris',  subjectEn:'English',          teacher:'Cikgu Rashid',  room:'B203', color:'#FEF3C7' },
    { subject:'Geografi',         subjectEn:'Geography',        teacher:'Cikgu Noraini', room:'A103', color:'#FFFBEB' },
    null,
  ]},
];

const DAY_LABELS_MS = ['Isnin','Selasa','Rabu','Khamis','Jumaat'];
const DAY_LABELS_EN = ['Monday','Tuesday','Wednesday','Thursday','Friday'];

export function ParentJadualPage({ user }: Props) {
  const { lang } = useLang();
  const E = lang === 'en';
  usePageTitle(E ? 'Timetable' : 'Jadual Waktu');

  const [showBanner, setShowBanner] = useState(true);

  return (
    <div style={{ maxWidth: '1100px' }}>
      {/* Page header */}
      <div className="page-header">
        <div>
          <h1 style={{ fontFamily: T.font.serif, fontSize: '24px', fontWeight: 700, color: T.color.textPrimary, marginBottom: '4px' }}>
            {E ? 'Timetable' : 'Jadual Waktu'}
          </h1>
          <p style={{ fontSize: '13px', color: T.color.textSecondary }}>
            {E ? 'Ahmad Zulfikri · Tingkatan 4A · Read-only' : 'Ahmad Zulfikri · Tingkatan 4A · Paparan sahaja'}
          </p>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button className="btn-secondary btn-sm" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Printer size={14} />
            {E ? 'Print' : 'Cetak Jadual'}
          </button>
          <button className="btn-primary btn-sm" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Download size={14} />
            {E ? 'Download PDF' : 'Muat Turun PDF'}
          </button>
        </div>
      </div>

      {/* Update banner */}
      {showBanner && (
        <div style={{
          background: '#FFFBEB', border: '1px solid #FCD34D', borderRadius: '8px',
          padding: '12px 16px', marginBottom: '20px',
          display: 'flex', alignItems: 'center', gap: '10px',
        }}>
          <AlertCircle size={16} color="#D97706" style={{ flexShrink: 0 }} />
          <span style={{ fontSize: '13px', color: '#92400E', flex: 1 }}>
            {E
              ? 'Timetable was updated on 1 June 2025. Please review any changes.'
              : 'Jadual telah dikemaskini pada 1 Jun 2025. Sila semak perubahan.'}
          </span>
          <button onClick={() => setShowBanner(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#D97706', fontSize: '18px', padding: 0, lineHeight: 1 }}>×</button>
        </div>
      )}

      {/* Week navigator */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
        <button className="btn-icon"><ChevronLeft size={18} /></button>
        <span style={{ fontSize: '14px', fontWeight: 600, color: T.color.textPrimary }}>
          {E ? 'Week of 2–6 June 2025' : 'Minggu 2–6 Jun 2025'}
        </span>
        <button className="btn-icon"><ChevronRight size={18} /></button>
      </div>

      {/* Timetable grid */}
      <div style={{ background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '10px', overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '760px' }}>
          <thead>
            <tr>
              <th style={{ padding: '12px 16px', background: '#F9FAFB', borderBottom: '1px solid #E5E7EB', fontSize: '11px', fontWeight: 700, color: '#6B7280', textAlign: 'left', width: '110px' }}>
                {E ? 'Period' : 'Waktu'}
              </th>
              {(E ? DAY_LABELS_EN : DAY_LABELS_MS).map((d, i) => (
                <th key={i} style={{ padding: '12px 8px', background: '#F9FAFB', borderBottom: '1px solid #E5E7EB', fontSize: '12px', fontWeight: 700, color: '#374151', textAlign: 'center', borderLeft: '1px solid #E5E7EB' }}>
                  {d}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {TIMETABLE.map((row, ri) => {
              const isRecess = row.period.period === RECESS_PERIOD;
              if (isRecess) {
                return (
                  <tr key={ri}>
                    <td colSpan={6} style={{ padding: '8px 16px', background: '#FFF8D6', borderBottom: '1px solid #E5E7EB', textAlign: 'center', fontSize: '12px', fontWeight: 600, color: '#92400E' }}>
                      {E ? `Recess · ${row.period.start}–${row.period.end}` : `Rehat · ${row.period.start}–${row.period.end}`}
                    </td>
                  </tr>
                );
              }
              return (
                <tr key={ri}>
                  <td style={{ padding: '8px 16px', borderBottom: '1px solid #F3F4F6', verticalAlign: 'middle' }}>
                    <div style={{ fontSize: '12px', fontWeight: 600, color: '#374151' }}>
                      {E ? `P${row.period.period}` : `Waktu ${row.period.period}`}
                    </div>
                    <div style={{ fontSize: '10px', color: '#9CA3AF', marginTop: '2px' }}>
                      {row.period.start}–{row.period.end}
                    </div>
                  </td>
                  {row.days.map((block, di) => (
                    <td key={di} style={{ padding: '6px 8px', borderBottom: '1px solid #F3F4F6', borderLeft: '1px solid #E5E7EB', verticalAlign: 'middle', minWidth: '120px' }}>
                      {block ? (
                        <div style={{ background: block.color, borderRadius: '6px', padding: '7px 10px' }}>
                          <div style={{ fontSize: '12px', fontWeight: 600, color: '#1E293B', lineHeight: 1.3 }}>
                            {E ? block.subjectEn : block.subject}
                          </div>
                          <div style={{ fontSize: '10px', color: '#64748B', marginTop: '2px' }}>{block.teacher}</div>
                          <div style={{ fontSize: '10px', color: '#94A3B8', marginTop: '1px' }}>{block.room}</div>
                        </div>
                      ) : (
                        <div style={{ fontSize: '11px', color: '#D1D5DB', textAlign: 'center' }}>—</div>
                      )}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Legend */}
      <div style={{ marginTop: '16px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        {[
          { color:'#DBEAFE', label: E?'Malay Language':'Bahasa Melayu' },
          { color:'#DCFCE7', label: E?'Mathematics':'Matematik' },
          { color:'#FEF3C7', label: E?'English':'Bahasa Inggeris' },
          { color:'#F5F3FF', label: E?'Islamic Studies':'Pendidikan Islam' },
        ].map(l => (
          <div key={l.label} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#6B7280' }}>
            <div style={{ width: '12px', height: '12px', borderRadius: '3px', background: l.color, flexShrink: 0 }} />
            {l.label}
          </div>
        ))}
      </div>
    </div>
  );
}
